module.exports = __webpack_public_path__ + "img/GameConfig.9d727da1.jpg";